import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
// @ts-expect-error module not typed
import { getCanonicalVid } from 'conversations-internal-schema/visitor/operators/visitorGetters';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
import { getHasFileAttachment, getInboxId, getOriginalGenericChannelId, getPreview, getStatus, getThreadId, getVid, getVisitor } from 'conversations-thread-data/thread-details/public/operators';
// @ts-expect-error module not typed
import ThreadPresence from 'conversations-thread-view/presence/components/ThreadPresence';
import styled from 'styled-components';
import { CapabilitiesEditor } from '../../../capability-editor/public/components';
import { flexColumnStyles } from '../../../editor-utilities/protected/constants';
import { ToolbarExpandButton } from '../../../pop-out/public/components';
import { ComposerSettingsMenu } from '../../../settings/protected/components';
import { ChannelTabs } from './ChannelTabs';
import { CommentTab } from './CommentTab';
import { TabbedEditorErrorState } from './TabbedEditorErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PositioningWrapper = styled.div.attrs(() => ({
  // This is a public API classname used for resizability functionality - DO NOT MODIFY
  className: 'TabbedEditorPositionWrapper'
})).withConfig({
  displayName: "TabbedEditor__PositioningWrapper",
  componentId: "sc-1qj1erj-0"
})(["position:relative;flex-grow:1;flex-shrink:1;", " min-width:100px;.ThreadPresence{margin-right:10px;}"], flexColumnStyles);
const TabPanelWrapper = styled.div.withConfig({
  displayName: "TabbedEditor__TabPanelWrapper",
  componentId: "sc-1qj1erj-1"
})(["flex-grow:1;display:flex;flex-direction:column;align-items:stretch;border-top:1px solid rgb(203,214,226);background:", ";"], OLAF);
const EditorDropdownWrapper = styled.div.withConfig({
  displayName: "TabbedEditor__EditorDropdownWrapper",
  componentId: "sc-1qj1erj-2"
})(["display:flex;border-top:1px solid ", ";background:", ";"], BATTLESHIP, OLAF);
const TabControlsGroup = styled.div.withConfig({
  displayName: "TabbedEditor__TabControlsGroup",
  componentId: "sc-1qj1erj-3"
})(["flex-grow:1;display:flex;"]);
const TabButtonsGroup = styled.div.withConfig({
  displayName: "TabbedEditor__TabButtonsGroup",
  componentId: "sc-1qj1erj-4"
})(["flex-shrink:1;display:flex;align-items:center;"]);
const DisabledMessage = styled.div.withConfig({
  displayName: "TabbedEditor__DisabledMessage",
  componentId: "sc-1qj1erj-5"
})(["padding:16px;text-align:center;"]);
function getComponentDataForLogging(threadDetails) {
  return threadDetails ? {
    threadId: getThreadId(threadDetails),
    genericChannelId: getOriginalGenericChannelId(threadDetails),
    status: getStatus(threadDetails),
    inboxId: getInboxId(threadDetails),
    preview: getPreview(threadDetails),
    vid: getVid(threadDetails),
    hasFileAttachment: getHasFileAttachment(threadDetails)
  } : {};
}
export function TabbedEditor({
  associatedObjectId,
  associatedObjectTypeId,
  asyncEmptyReply,
  callingSource,
  canSubmit = true,
  capabilitiesBlob,
  className,
  currentChannelId,
  disableCalling,
  disabled,
  disabledMessage,
  editorComponent,
  expandable = false,
  isKnownVisitor,
  isLoading,
  isUngatedForRRSettings,
  latestCMFGenericChannelId,
  onCloseShepherd,
  onSelectedChange,
  originalGenericChannelId,
  renderExistingFileSelect,
  renderSubmitButton,
  replyRecommendationsEnabled,
  sendDisabledValidator,
  submitHandler,
  threadDetails
}) {
  if (disabled) {
    return /*#__PURE__*/_jsx(DisabledMessage, {
      children: disabledMessage
    });
  }
  const visitor = getVisitor(threadDetails);
  const subjectId = getCanonicalVid(visitor);
  const inboxId = getInboxId(threadDetails);
  const threadId = getThreadId(threadDetails);
  const eligibleChannel = currentChannelId !== WHATSAPP_GENERIC_CHANNEL_ID;
  const displayComposerSettings = eligibleChannel && replyRecommendationsEnabled && isUngatedForRRSettings;
  const TabbedComponent = editorComponent || CapabilitiesEditor;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    renderError: TabbedEditorErrorState,
    errorLoggingTitle: "An uncaught TabbedChannels error occurred",
    errorBoundaryName: "TabbedChannelsBoundary",
    onGetComponentDataForLogging: () => getComponentDataForLogging(threadDetails),
    children: /*#__PURE__*/_jsxs(PositioningWrapper, {
      children: [isLoading || !originalGenericChannelId ? /*#__PURE__*/_jsx(UILoadingOverlay, {
        use: "dots",
        contextual: true
      }) : /*#__PURE__*/_jsxs(EditorDropdownWrapper, {
        children: [/*#__PURE__*/_jsxs(TabControlsGroup, {
          children: [/*#__PURE__*/_jsx(ChannelTabs, {
            associatedObjectId: associatedObjectId,
            associatedObjectTypeId: associatedObjectTypeId,
            currentChannelId: currentChannelId,
            callingSource: callingSource,
            disableCalling: disableCalling,
            isKnownVisitor: isKnownVisitor,
            onSelectedChange: onSelectedChange,
            originalGenericChannelId: originalGenericChannelId,
            subjectId: subjectId,
            inboxId: inboxId,
            threadId: `${threadId}`
          }), /*#__PURE__*/_jsx(CommentTab, {
            currentChannelId: currentChannelId,
            onSelectedChange: onSelectedChange
          })]
        }), /*#__PURE__*/_jsxs(TabButtonsGroup, {
          children: [/*#__PURE__*/_jsx(ThreadPresence, {
            threadId: threadId
          }), displayComposerSettings && /*#__PURE__*/_jsx(ComposerSettingsMenu, {}), expandable && /*#__PURE__*/_jsx(ToolbarExpandButton, {
            editorKey: "replyEditor"
          })]
        })]
      }), /*#__PURE__*/_jsx(TabPanelWrapper, {
        children: !isLoading && capabilitiesBlob && /*#__PURE__*/_jsx(TabbedComponent, {
          asyncEmptyReply: asyncEmptyReply,
          canSubmit: canSubmit,
          capabilitiesBlob: capabilitiesBlob,
          className: className,
          currentChannelId: currentChannelId,
          latestCMFGenericChannelId: latestCMFGenericChannelId,
          onCloseShepherd: onCloseShepherd,
          originalGenericChannelId: originalGenericChannelId || null,
          renderExistingFileSelect: renderExistingFileSelect,
          replyRecommendationsEnabled: replyRecommendationsEnabled,
          renderSubmitButton: renderSubmitButton,
          sendDisabledValidator: sendDisabledValidator,
          submitHandler: submitHandler,
          threadDetails: threadDetails
        })
      })]
    })
  });
}
TabbedEditor.displayName = '';